import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get (query = '') {
    return ApiService.get(`cash-management-officer/dashboard?${query}`)
  }
}

export default DashboardService
